import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';

@Component({
  selector: 'app-review-ecmodal',
  templateUrl: './review-ecmodal.component.html',
  styleUrls: ['./review-ecmodal.component.css']
})
export class ReviewECModalComponent implements OnInit {

  @Input() id: any;
  contactList: any[];
  portalSettings: any;
  country: string;

  constructor(private hiringService: HiringService, public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.country = this.portalSettings.CountryDateCode.ConfigValue;
   }

  ngOnInit(): void {
    this.getContact();
  }

  getContact() {
    this.hiringService.getOnboardEmergencyContacts(this.id).then((response: any) => {
      if (response != null) {
        this.contactList = response;
      }
    });
  }

  expendRow(data: any) {
    data.Expended = !data.Expended;
  }

  closeClick = function () {
    this.activeModal.dismiss();
  }
}
